import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * On every route change: scroll to the top and move focus to the main content
 * region. This fixes the SPA a11y gap where navigation leaves focus stranded and
 * the viewport scrolled — screen-reader + keyboard users now land on the new page.
 * Honors prefers-reduced-motion (jumps instead of smooth-scrolling).
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    const main = document.getElementById('main-content');
    if (main) {
      main.setAttribute('tabindex', '-1');
      main.focus({ preventScroll: true });
    }
  }, [pathname]);
  return null;
}
